import { Dropdown, DropdownOption, Icon } from "@abb/abb-common-ux-react";
import moment from "moment";
import React from "react";
import { Translation } from "react-i18next";
import * as CONSTANTS from "../../utilities/Constants";

import { DatePicker, Space } from "antd";
import "antd/dist/antd.css";
import DateFormatting from "../../utilities/DateFormat";

interface IProps {
  selectFromDate: string;
  selectToDate: string;
  selectedDateRange: any[];
  gradeList: any[];
  selectedGrade: any[];
  measurementStatusList: any[];
  selectedMeasurementStatus: any[];
  productList: any[];
  selectedProduct: any[];
  sourceList: any[];
  selectedSource: any[];

  dateRangeHandler: (value: any) => void;
  setTrendCustomFromDate: (value: any) => void;
  setTrendCustomToDate: (value: any) => void;
  measurementStatusHandler: (value: any) => void;
  gradeChangeHandler: (value: any) => void;
  productChangeHandler: (value: any) => void;
  sourceChangeHandler: (value: any) => void;
  onDateFocus?: () => any;

  reSet?: () => void;
  clearAllFilters?: () => void;
  hasFiltersChanged?: boolean;

  showSelectFilterHandler?: () => void;
}
interface IState {}

export default class SampleFilter extends React.Component<IProps, IState> {
  private _datetimeFormat = "YYYY-MM-DD HH:mm:ss";
  private daterange = CONSTANTS.DATE_RANGES;

  public render() {
    return (
      <Translation>
        {(t) => (
          <React.Fragment>
            <div>
              <div
                style={{
                  padding: "8px 8px 8px 8px",
                  marginTop: "16px",
                  height: "calc(100vh - 6rem)",
                  width: "15rem",
                  overflowX: "hidden",
                  overflowY: "hidden",
                  border: "1px solid black",
                  zIndex: 1000,
                  left: "220px",
                  position: "fixed",
                  background: "#F5F5F5",
                  borderRadius: "10px",
                }}
              >
                <div className="float-right ">
                  <Icon
                    name="abb/close"
                    className="filter-circle"
                    sizeClass="small"
                    onClick={this.props.showSelectFilterHandler}
                    style={{ padding: "4px" }}
                  />
                </div>
                <div style={{ marginTop: "3rem" }}>
                  <div
                    className="drawer-header-bg mt-2"
                    style={{ overflowY: "auto" }}
                  >
                    <div className="bg-color">
                      <span className="sidebar-title font-weight-bold">
                        {" "}
                        {t(CONSTANTS.LABEL_SELECT_FILTER)}{" "}
                      </span>
                    </div>
                    <div style={{ padding: "0px 8px" }}>
                      <div className="row">
                        <div className="col-sm col-md">
                          <Dropdown
                            label={t(CONSTANTS.LABEL_DATE_MODIFIED)}
                            allowAdd={false}
                            clearable={false}
                            placeholder={t(CONSTANTS.LABEL_SELECT)}
                            value={this.props.selectedDateRange}
                            onChange={this.props.dateRangeHandler}
                          >
                            {this.daterange.map((o: any) => (
                              <DropdownOption
                                key={o.value}
                                label={o.label}
                                value={o.value}
                              />
                            ))}
                          </Dropdown>
                        </div>
                      </div>
                      {this.props.selectedDateRange[0]?.value === 4 && (
                        <div>
                          <div className="row trend">
                            <div className="col-sm col-md">
                              <div className="custom-label">
                                {t(CONSTANTS.FROM)}
                              </div>
                              <Space direction="vertical" size={12}>
                                <DatePicker
                                  format={
                                    DateFormatting.getDateTimeRegion() ||
                                    "DD-MM-YYYY hh:mm A"
                                  }
                                  showTime={{
                                    use12Hours: true,
                                    format: "hh:mm A",
                                  }}
                                  defaultValue={
                                    this.props.selectFromDate
                                      ? moment(this.props.selectFromDate)
                                      : null
                                  }
                                  onChange={this.props.setTrendCustomFromDate}
                                  onOk={this.props.setTrendCustomFromDate}
                                  allowClear={true}
                                  bordered={true}
                                  placeholder={
                                    DateFormatting.getDateTimeRegion() ||
                                    "DD-MM-YYYY hh:mm A"
                                  }
                                  onFocus={this.props.onDateFocus}
                                />
                              </Space>
                            </div>
                          </div>
                          <div className="row trend">
                            <div className="col-sm col-md">
                              <div className="custom-label">
                                {t(CONSTANTS.TO)}
                              </div>
                              <Space direction="vertical" size={12}>
                                <DatePicker
                                  format={
                                    DateFormatting.getDateTimeRegion() ||
                                    "DD-MM-YYYY hh:mm A"
                                  }
                                  showTime={{
                                    use12Hours: true,
                                    format: "hh:mm A",
                                  }}
                                  defaultValue={
                                    this.props.selectToDate
                                      ? moment(this.props.selectToDate)
                                      : null
                                  }
                                  onChange={this.props.setTrendCustomToDate}
                                  onOk={this.props.setTrendCustomToDate}
                                  allowClear={true}
                                  bordered={true}
                                  placeholder={
                                    DateFormatting.getDateTimeRegion() ||
                                    "DD-MM-YYYY hh:mm A"
                                  }
                                  dropdownClassName="dropdown_class_name_1"
                                  onFocus={this.props.onDateFocus}
                                />
                              </Space>
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="row">
                        <div className="col-sm col-md">
                          <Dropdown
                            label="Measurement Status"
                            allowAdd={false}
                            clearable={false}
                            multiselect={true}
                            searchable={true}
                            placeholder={t(CONSTANTS.LABEL_SELECT)}
                            value={this.props.selectedMeasurementStatus}
                            onChange={this.props.measurementStatusHandler}
                          >
                            {this.props.measurementStatusList.map((o: any) => (
                              <DropdownOption
                                key={o.value}
                                label={t(
                                  o.label
                                    .toString()
                                    .trim()
                                    .includes("NotMeasured")
                                    ? "Pending"
                                    : o.label
                                )}
                                value={o.value}
                              />
                            ))}
                          </Dropdown>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm col-md">
                          <Dropdown
                            label={t(CONSTANTS.MODULE_GRADE)}
                            allowAdd={false}
                            clearable={false}
                            multiselect={true}
                            searchable={true}
                            placeholder={t(CONSTANTS.LABEL_SELECT)}
                            value={this.props.selectedGrade}
                            onChange={this.props.gradeChangeHandler}
                          >
                            {this.props.gradeList.map((o) => (
                              <DropdownOption
                                key={o.value}
                                label={o.label}
                                value={o.value}
                              />
                            ))}
                          </Dropdown>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm col-md">
                          <Dropdown
                            label={t(CONSTANTS.MODULE_PRODUCT)}
                            allowAdd={false}
                            clearable={false}
                            multiselect={true}
                            searchable={true}
                            value={this.props.selectedProduct}
                            onChange={this.props.productChangeHandler}
                            placeholder={t(CONSTANTS.LABEL_SELECT)}
                          >
                            {this.props.productList.map((o) => (
                              <DropdownOption
                                key={o.value}
                                label={o.label}
                                value={o.value}
                              />
                            ))}
                          </Dropdown>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm col-md">
                          <Dropdown
                            label={t(CONSTANTS.MODULE_SOURCE)}
                            allowAdd={false}
                            clearable={false}
                            multiselect={true}
                            searchable={true}
                            placeholder={t(CONSTANTS.LABEL_SELECT)}
                            value={this.props.selectedSource}
                            onChange={this.props.sourceChangeHandler}
                          >
                            {this.props?.sourceList?.map((o: any) => (
                              <DropdownOption
                                key={o.value}
                                label={o.label}
                                value={o.value}
                              />
                            ))}
                          </Dropdown>
                        </div>
                      </div>
                      {this.props.hasFiltersChanged && (
                        <div
                          className="clear-filter"
                          onClick={this.props.clearAllFilters}
                        >
                          <Icon name="abb/close" />{" "}
                          {t(CONSTANTS.CLEAR_ALL_FILTERS)}{" "}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </Translation>
    );
  }
}
